import number from '../../views/pages/number'
import { types } from '../types'

const initialState = {
  WaitingProfile: false,
  SuccessProfile: false,
  ErrorProfile: '',
  profile: {},


  WaitingProfileResetMobileVerificatiom: false,
  SuccessProfileResetMobileVerificatiom: false,
  ErrorProfileResetMobileVerificatiom: '',
  StatusProfileResetMobileVerificatiom: {},


  WaitingProfileVerifyMobile: false,
  SuccessProfileVerifyMobile: false,
  ErrorProfileVerifyMobile: '',
  StatusProfileVerifyMobile: 0,

  WaitingProfileGetProvinceWithCity: false,
  SuccessProfileGetProvinceWithCity: false,
  ErrorProfileGetProvinceWithCity: '',
  listProvinceAndCity: [],

  WaitingProfileSave: false,
  SuccessProfileSave: false,
  ErrorProfileSave: '',
  statusSave: {},

  WaitingResendEmailVerification: false,
  SuccessResendEmailVerification: false,
  ErrorResendEmailVerification: '',
  statusResendEmailVerification: false,

  WaitingChangePasword: false,
  SuccessChangePasword: false,
  ErrorChangePasword: '',
  statusChangePasword: false,

  WaitingAddNewEmail: false,
  SuccessAddNewEmail: false,
  ErrorAddNewEmail: '',
  StatusAddNewEmail: number,
  SuccessResponseAddNewEmail: false,
  MessageResponseAddNewEmail: '',

  WaitingRejectNewEmail: false,
  SuccessRejectNewEmail: false,
  ErrorRejectNewEmail: '',
  StatusRejectNewEmail: number,
  SuccessResponseRejectNewEmail: false,
  MessageResponseRejectNewEmail: '',

  WaitingChangeEmailVerificationEmail: false,
  SuccessChangeEmailVerificationEmail: false,
  ErrorChangeEmailVerificationEmail: '',

  statusChangePasword: false

}

const profileReducer = (state = initialState, { type, action, error }) => {
  switch (type) {
    /*************************************************************************** */
    case types.GET_PROFILE_REQUEST: {
      return {
        ...state,
        waitingProfile: true,
        SuccessProfile: false,
        profile: {},
        ErrorProfile: ''

      }
    }
    case types.GET_PROFILE_SUCCESS: {

      return {
        ...state,
        WaitingProfile: false,
        SuccessProfile: true,
        profile: action.data,
      }
    }
    case types.GET_PROFILE_ERROR: {

      return {
        ...state,
        WaitingProfile: false,
        ErrorProfile: action?.payload,

      }
    }
    case types.GET_PROFILE_RESET_PROPS: {

      return {
        ...state,
        WaitingProfile: false,
        SuccessProfile: false,
        ErrorProfile: '',
        // profile: {},
      }
    }
    /********************************************************************************* */
    case types.PROFILE_RESEND_MOBILE_VERIFICATION_CODE_REQUEST: {
      return {
        ...state,
        WaitingProfileResetMobileVerificatiom: true,
        SuccessProfileResetMobileVerificatiom: false,
        ErrorProfileResetMobileVerificatiom: ''
      }
    }
    case types.PROFILE_RESEND_MOBILE_VERIFICATION_CODE_SUCCESS: {
      return {
        ...state,
        WaitingProfileResetMobileVerificatiom: false,
        SuccessProfileResetMobileVerificatiom: true,
        ErrorProfileResetMobileVerificatiom: '',
        StatusProfileResetMobileVerificatiom: action.data,
      }
    }
    case types.PROFILE_RESEND_MOBILE_VERIFICATION_CODE_ERROR: {
      return {
        ...state,
        WaitingProfileResetMobileVerificatiom: false,
        SuccessProfileResetMobileVerificatiom: false,
        ErrorProfileResetMobileVerificatiom: action.payload,
      }
    }
    case types.PROFILE_RESEND_MOBILE_VERIFICATION_CODE_RESET_PROPS: {
      return {
        ...state,
        WaitingProfileResetMobileVerificatiom: false,
        SuccessProfileResetMobileVerificatiom: false,
        ErrorProfileResetMobileVerificatiom: '',
        StatusProfileResetMobileVerificatiom: {},
      }
    }
    //**************************************************************************** */
    case types.PROFILE_VERIFY_MOBILE_REQUEST: {
      return {
        ...state,
        WaitingProfileVerifyMobile: true,
        SuccessProfileVerifyMobile: false,
        ErrorProfileVerifyMobile: ''
      }
    }
    case types.PROFILE_VERIFY_MOBILE_SUCCESS: {
      return {
        ...state,
        WaitingProfileVerifyMobile: false,
        SuccessProfileVerifyMobile: true,
        ErrorProfileVerifyMobile: '',
        StatusProfileVerifyMobile: action.data,
      }
    }
    case types.PROFILE_VERIFY_MOBILE_ERROR: {

      return {
        ...state,
        WaitingProfileVerifyMobile: false,
        SuccessProfileVerifyMobile: false,
        ErrorProfileVerifyMobile: 'error',
      }
    }
    case types.PROFILE_VERIFY_MOBILE_RESET_PROPS: {
      return {
        ...state,
        WaitingProfileVerifyMobile: false,
        SuccessProfileVerifyMobile: false,
        ErrorProfileVerifyMobile: '',
        StatusProfileVerifyMobile: 0,
      }
    }
    //************************************************************************* */
    case types.PROFILE_GET_PROVINCE_WITH_CITY_REQUEST:
      {
        return {
          ...state,
          WaitingProfileGetProvinceWithCity: true,
          SuccessProfileGetProvinceWithCity: false,
          ErrorProfileGetProvinceWithCity: ''
        }
      }
    case types.PROFILE_GET_PROVINCE_WITH_CITY_SUCCESS: {
      return {
        ...state,
        WaitingProfileGetProvinceWithCity: false,
        SuccessProfileGetProvinceWithCity: true,
        ErrorProfileGetProvinceWithCity: '',
        listProvinceAndCity: action.data,
      }
    }
    case types.PROFILE_GET_PROVINCE_WITH_CITY_ERROR: {
      return {
        ...state,
        WaitingProfileGetProvinceWithCity: false,
        SuccessProfileGetProvinceWithCity: false,
        ErrorProfileGetProvinceWithCity: action.payload,
      }
    }
    case types.PROFILE_GET_PROVINCE_WITH_CITY_RESET_PROPS: {
      return {
        ...state,
        WaitingProfileGetProvinceWithCity: false,
        SuccessProfileGetProvinceWithCity: false,
        ErrorProfileGetProvinceWithCity: '',
        listProvinceAndCity: [],
      }
    }
    //***************************************************************************** */
    case types.PROFILE_SAVE_REQUEST:
      {
        return {
          ...state,
          WaitingProfileSave: true,
          SuccessProfileSave: false,
          ErrorProfileSave: ''
        }
      }
    case types.PROFILE_SAVE_SUCCESS: {
      return {
        ...state,
        WaitingProfileSave: false,
        SuccessProfileSave: true,
        ErrorProfileSave: '',
        statusSave: action.data,
      }
    }
    case types.PROFILE_SAVE_ERROR: {
      return {
        ...state,
        WaitingProfileSave: false,
        SuccessProfileSave: false,
        ErrorProfileSave: action.payload,
      }
    }
    case types.PROFILE_SAVE_RESET_PROPS: {
      return {
        ...state,
        WaitingProfileSave: false,
        SuccessProfileSave: false,
        ErrorProfileSave: '',
        statusSave: {},
      }
    }
    //******************************************************************************** */
    case types.RESEND_EMAIL_VERIFICATION_REQUEST:
      {
        return {
          ...state,
          WaitingResendEmailVerification: true,
          SuccessResendEmailVerification: false,
          ErrorResendEmailVerification: ''
        }
      }
    case types.RESEND_EMAIL_VERIFICATION_SUCCESS: {
      return {
        ...state,
        WaitingResendEmailVerification: false,
        SuccessResendEmailVerification: true,
        ErrorResendEmailVerification: '',
        statusResendEmailVerification: action.data,
      }
    }
    case types.RESEND_EMAIL_VERIFICATION_ERROR: {
      return {
        ...state,
        WaitingResendEmailVerification: false,
        SuccessResendEmailVerification: false,
        ErrorResendEmailVerification: action.payload,
      }
    }
    case types.RESEND_EMAIL_VERIFICATION_RESET_PROPS: {
      return {
        ...state,
        WaitingResendEmailVerification: false,
        SuccessResendEmailVerification: false,
        ErrorResendEmailVerification: '',
        statusResendEmailVerification: false,
      }
    }
    //******************************************************************************** */
    case types.PROFILE_CHANGE_PASSWORD_REQUEST:
      {
        return {
          ...state,
          WaitingChangePasword: true,
          SuccessChangePasword: false,
          ErrorChangePasword: ''
        }
      }
    case types.PROFILE_CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state,
        WaitingChangePasword: false,
        SuccessChangePasword: true,
        ErrorChangePasword: '',
        statusChangePasword: action.data,
      }
    }
    case types.PROFILE_CHANGE_PASSWORD_ERROR: {
      return {
        ...state,
        WaitingChangePasword: false,
        SuccessChangePasword: false,
        ErrorChangePasword: action.payload,
      }
    }
    case types.PROFILE_CHANGE_PASSWORD_RESET_PROPS: {
      return {
        ...state,
        WaitingChangePasword: false,
        SuccessChangePasword: false,
        ErrorChangePasword: '',
        statusChangePasword: false,
      }
    }
    //********************************************************************** */

    case types.ADD_NEW_EMAIL_REQUEST: {
      return {
        ...state,
        WaitingAddNewEmail: true,
        SuccessAddNewEmail: false,
        ErrorAddNewEmail: '',
        SuccessResponseAddNewEmail: false,
        StatusAddNewEmail: 0,
        MessageResponseAddNewEmail: ''
      }
    }
    case types.ADD_NEW_EMAIL_SUCCESS: {
      return {
        ...state,
        WaitingAddNewEmail: false,
        SuccessAddNewEmail: true,
        ErrorAddNewEmail: '',
        SuccessResponseAddNewEmail: action.data?.Success,
        StatusAddNewEmail: action.data?.Status,
        MessageResponseAddNewEmail: action.data?.Message
      }
    }
    case types.ADD_NEW_EMAIL_ERROR: {
      return {
        ...state,
        WaitingAddNewEmail: false,
        SuccessAddNewEmail: false,
        ErrorAddNewEmail: action.payload,
        SuccessResponseAddNewEmail: false,
        StatusAddNewEmail: 0,
        MessageResponseAddNewEmail: ''
      }
    }

    //************************************************************************ */
    case types.CHANGE_EMAIL_VERIFICATION_REQUEST: {
      return {
        ...state,
        WaitingChangeEmailVerificationEmail: true,
        SuccessChangeEmailVerificationEmail: false,
        ErrorChangeEmailVerificationEmail: '',
      }
    }
    case types.CHANGE_EMAIL_VERIFICATION_SUCCESS: {
      return {
        ...state,
        WaitingChangeEmailVerificationEmail: false,
        SuccessChangeEmailVerificationEmail: true,
        ErrorChangeEmailVerificationEmail: action?.data,

      }
    }
    case types.CHANGE_EMAIL_VERIFICATION_ERROR: {
      return {
        ...state,
        WaitingChangeEmailVerificationEmail: false,
        SuccessChangeEmailVerificationEmail: false,
        ErrorChangeEmailVerificationEmail: action.payload,
      }
    }
    //******************************************************************************* */

    case types.REJECT_NEW_EMAIL_REQUEST: {
      return {
        ...state,
        WaitingRejectNewEmail: true,
        SuccessRejectNewEmail: false,
        ErrorRejectNewEmail: '',
        StatusRejectNewEmail: 0,
        SuccessResponseRejectNewEmail: false,
        MessageResponseRejectNewEmail: '',
      }
    }
    case types.REJECT_NEW_EMAIL_SUCCESS: {
      return {
        ...state,
        WaitingRejectNewEmail: false,
        SuccessRejectNewEmail: true,
        ErrorRejectNewEmail: '',
        StatusRejectNewEmail: action.data?.Status,
        SuccessResponseRejectNewEmail: action.data?.Success,
        MessageResponseRejectNewEmail: action.data?.Message,

      }
    }
    case types.REJECT_NEW_EMAIL_ERROR: {
      return {
        ...state,
        WaitingRejectNewEmail: false,
        SuccessRejectNewEmail: false,
        ErrorREjectNewEmail: '',
        StatusRejectNewEmail: 0,
        SuccessResponseRejectNewEmail: false,
        MessageResponseRejectNewEmail: action.payload,
      }
    }

    case types.RESET_PROFILE: {
      return {
        ...state,

        WaitingProfileResetMobileVerificatiom: false,
        SuccessProfileResetMobileVerificatiom: false,
        ErrorProfileResetMobileVerificatiom: '',
        StatusProfileResetMobileVerificatiom: {},


        WaitingProfileVerifyMobile: false,
        SuccessProfileVerifyMobile: false,
        ErrorProfileVerifyMobile: '',
        StatusProfileVerifyMobile: 0,

        WaitingProfileGetProvinceWithCity: false,
        SuccessProfileGetProvinceWithCity: false,
        ErrorProfileGetProvinceWithCity: '',
        listProvinceAndCity: [],

        WaitingProfileSave: false,
        SuccessProfileSave: false,
        ErrorProfileSave: '',
        statusSave: {},

        WaitingResendEmailVerification: false,
        SuccessResendEmailVerification: false,
        ErrorResendEmailVerification: '',
        statusResendEmailVerification: false,

        WaitingChangePasword: false,
        SuccessChangePasword: false,
        ErrorChangePasword: '',
        statusChangePasword: false,

        WaitingAddNewEmail: false,
        SuccessAddNewEmail: false,
        ErrorAddNewEmail: '',
        StatusAddNewEmail: number,
        SuccessResponseAddNewEmail: false,
        MessageResponseAddNewEmail: '',

        WaitingRejectNewEmail: false,
        SuccessRejectNewEmail: false,
        ErrorRejectNewEmail: '',
        StatusRejectNewEmail: number,
        SuccessResponseRejectNewEmail: false,
        MessageResponseRejectNewEmail: '',

        WaitingChangeEmailVerificationEmail: false,
        SuccessChangeEmailVerificationEmail: false,
        ErrorChangeEmailVerificationEmail: '',

        statusChangePasword: false

      }
    }


    default:
      return state
  }
}

export default profileReducer;